<template>
  <div>
    <transition name="myself-dialog-fade">
      <div class="show_box_father" v-if="dialogFlag" @click="clickMask">
        <div class="show_box_son" @click.stop :style="{width, padding: p_lr, borderRadius}">
          <div v-if="hideMaskFlag" class="close_icon ZHIHUISHU_QZMD" @click="$emit('hideMask')">
            <img src="//image.zhihuishu.com/zhs/ablecommons/zhangying/202110/322b44f4a1e34d8cb527d1e033ec659b.png" alt="关闭">
          </div>
          <slot></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    dialogFlag:{
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '1200px'
    },
    p_lr: {
      type: String,
      default: '0 20px'
    },
    borderRadius: {
      type: String,
      default: '10px'
    },
    hideMaskFlag: {
      type: Boolean,
      default: true
    },
    clickMaskForHide: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    clickMask () {
      if (this.clickMaskForHide) {
        this.$emit('hideMask')
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@mixin showBoxFather() {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 10;
  overflow: auto;
}
@mixin AnyElementCentered() {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.show_box_father {
  @include showBoxFather();
  .show_box_son {
    height: auto;
    background-color: #fff;
    position: absolute;
    @include AnyElementCentered();
    display: flex;
    flex-direction: column;
    z-index: 15;
    .close_icon {
      width: 24px;
      height: 24px;
      position: absolute;
      top: 17px;
      right: 30px;
      z-index: 15;
      display: flex;
      align-items: flex-start;
      justify-content: flex-end;
      cursor: pointer;
      img {
        width: 12px;
        height: 12px;
        cursor: pointer;
      }
    }
  }
}

.myself-dialog-fade-enter-active {
  animation: dialog-fadein 0.4s;
  .show_box_son {
    animation: dialog-zoom 0.4s;
  }
}
  
.myself-dialog-fade-leave-active {
  animation: dialog-fadeout 0.4s;
  .show_box_son {
    animation: dialog-out 0.4s;
  }
}
  
@keyframes dialog-fadein {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
  
@keyframes dialog-fadeout {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}
  
@keyframes dialog-zoom {
  0% {
    transform: translate(-50%, -50%) scale(0);
  }

  50% {
    transform: translate(-50%, -50%) scale(1.1);
  }

  100% {
    transform: translate(-50%, -50%) scale(1);
  }
}
  
@keyframes dialog-out {
  0% {
    transform: translate(-50%, -50%) scale(1);
  }

  50% {
    transform: translate(-50%, -50%) scale(1.1);
  }

  100% {
    transform: translate(-50%, -50%) scale(0);
  }
}
</style>